<h2>
    Medical Exam Certificate
    <button *ngIf="editorEnabled" class="icon--add btn--default" (click)="createMedicalExamCertificateModel()" type="button">Add MEC</button>
    <button class="icon--history btn--default" (click)="showHistory()" type="button">View History</button>
</h2>
<p-table [value]="certs" styleClass="mvd_table--nest">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="editorEnabled ? 12 : 11">
                No Records Found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Id</th>
            <th>Decision</th>
            <th>Restrictions</th>
            <th>Is Long</th>
            <th>Registry Code</th>
            <th>Issuing State</th>
            <th>Signature Date</th>
            <th>Expiration Date</th>
            <th>Status</th>
            <th>Status Date</th>
            <th>Updated</th>
            <th *ngIf="editorEnabled" class="w--actions-3">Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data let-expanded="expanded">
        <tr [pSelectableRow]="data">
            <td class="w--scr-description" (click)="openMedicalExamCertificateModal(data, true)">
                <a href="javascript:void(0)">{{ data.id }}</a>
            </td>
            <td>
                {{ data.decisionDisplayValue }}
            </td>
            <td>
                {{ data.restrictionDisplayValues }}
            </td>
            <td>
                {{ data.isLongMedicalExamForm }}
            </td>
            <td>
                {{ data.medicalExaminerRegistryCode }}
            </td>
            <td>
                {{ data.jurisdictionDisplayValue }}
            </td>
            <td>
                {{ data.medicalExamCertificateSignatureDate | shortDate }}
            </td>
            <td>
                {{ data.expirationDate | shortDate }}
            </td>
            <td *ngIf="canDeleteMedCert" class="w--scr-description" (click)="openMedicalExamCertificateStatusModal(data)">
                <a href="javascript:void(0)">
                    {{ data.driverMedicalCertificateStatusTypeDisplayValue }}
                </a>
            </td>
            <td *ngIf="!canDeleteMedCert">
                {{ data.driverMedicalCertificateStatusTypeDisplayValue }}
            </td>
            <td>
                {{ data.qualificationStatusDate | shortDate }}
            </td>
            <td>
                {{ data.updatedDate | shortDate }}
            </td>
            <td *ngIf="editorEnabled">
                <a *ngIf="topOfStackCert !== null" class="icon--edit" href="javascript:void(0)" title="Edit Report" (click)="openMedicalExamCertificateModal(data, false)"></a>
                <a *ngIf="topOfStackCert !== null && canDeleteMedCert" class="icon--delete" href="javascript:void(0)" title="Delete Work Item" (click)="openDeleteMedicalExamCertificateModal(data)"></a>
            </td>
        </tr>
    </ng-template>
</p-table>